import { type ReactNode, useContext, useEffect } from 'react'

import { useFormattedText } from '../useFormattedText'
import { context } from './context'

type Props = {
	children?: ReactNode
}

export const Title = ({ children }: Props) => {
	const { onTitleUpdate } = useContext(context)

	const formatted = useFormattedText(children)

	useEffect(() => {
		onTitleUpdate(formatted)

		return () => onTitleUpdate('')
	}, [formatted, onTitleUpdate])

	return null
}
